// SORT COMPARATORS
// =====

export const compareAsDates = (a, b) =>
  new Date(a).valueOf() - new Date(b).valueOf();

// ISO Timezone Strings
// =====

interface IDateDTO {
  YYYY :number | string;
  MM :string;
  DD :string;
  HH :string;
  mm :string;
  ss :string;
}
interface IDateTimezoneDTO {
  ZO :'+' | '-' | 'Z';
  ZH :string;
  ZM :string;
}

const _pad = (num :number) => (num < 10 ? '0' : '') + num;
const getDatePieces = (date :Date) :IDateDTO => ({
  YYYY: date.getFullYear(),
  MM: _pad(date.getMonth() + 1),
  DD: _pad(date.getDate()),
  HH: _pad(date.getHours()),
  mm: _pad(date.getMinutes()),
  ss: _pad(date.getSeconds()),
});
const getTimezonePieces = (date :Date) :IDateTimezoneDTO => {
  const offset = -date.getTimezoneOffset();

  if (offset === 0) {
    return { ZO: 'Z', ZH: '', ZM: '' };
  }

  return {
    ZO: offset >= 0 ? '+' : '-',
    ZH: _pad(Math.floor(Math.abs(offset) / 60)),
    ZM: _pad(Math.abs(offset) % 60),
  };
};

export const getISOTimzoneString = (date ?:Date) :string => {
  date ??= new Date();

  const { YYYY, MM, DD, HH, mm, ss } = getDatePieces(date);
  const { ZO, ZH, ZM } = getTimezonePieces(date);

  const Z = ZO === 'Z' ? 'Z' : `${ZO}${ZH}:${ZM}`;

  return `${YYYY}-${MM}-${DD}T${HH}:${mm}:${ss}${Z}`;
};
export const getISOTimzoneFSSafeString = (date ?:Date) :string => {
  date ??= new Date();

  const { YYYY, MM, DD, HH, mm, ss } = getDatePieces(date);
  const { ZO, ZH, ZM } = getTimezonePieces(date);

  const Z = ZO === 'Z' ? 'Z' : `${ZO}${ZH}${ZM}`.replace('+', '');

  return `${YYYY}${MM}${DD}T${HH}${mm}${ss}${Z}`;
};
